<!--htmlhint inline-style-disabled:false -->
<div class="content landing scroll">
  <div class="container has-text-centered">
    <div class="column">
      <div class="logo-box">
        <img src="assets/caddie_logo.png" style="height: 300px">
      </div>

      <!--
      <div class="video-container">
        <div class="has-text-centered video-box">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/yK1rbFi5wW0" frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
          </iframe>
        </div>
        <div class="has-text-centered video-box">
          <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/H9pbYQFlt6U" frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
          </iframe>
        </div>
      </div>
      -->

      <div class="button-box">
        <button class="button has-text-primary is-large">
          <a routerLink="/simple" routerLinkActive="is-active">
            <span class="icon"><i class="fa fa-capsules has-text-primary"></i></span>
            <span>Quick Drug Search</span>
          </a>
        </button>
        <button class="button has-text-primary is-large">
          <a routerLink="/explorer" routerLinkActive="is-active">
            <span class="icon"><i class="fa fa-project-diagram has-text-primary"></i></span>
            <span>Explore</span>
          </a>
        </button>
      </div>

      <div class="text-box">
        <h1 class="subtitle is-3">
          Explore the interactome of {{ cancerDriverGenesN }} cancer driver genes.
        </h1>
        <h1 class="subtitle is-3">
          Use detailed information from {{ genesN }} genes to find putative drug targets.
        </h1>
        <h1 class="subtitle is-3">
          Repurpose drugs from {{ drugsN }} drugs using network biology algorithms.
        </h1>
      </div>

    </div>
  </div>
</div>
